import React from 'react';
import PropTypes from 'prop-types';
import ExpensesSection from '../ExpensesSection';

const SimpleExpensesTab = ({ ctrl }) => (
  <div style={{ paddingBottom: 200 }}>
    <ExpensesSection
    csrfToken={ctrl.csrfToken}
    team={ctrl.team}
    currentUser={ctrl.currentUser}
    offer={ctrl.offer}
    budget={ctrl.budgetForComponents}
    calculated={ctrl.calculated}
    updateBudget={ctrl.handleUpdateBudget}
    createExpensesBudgetLineItem={ctrl.handleCreateExpenseLineItem}
    createDeductionBudgetLineItem={ctrl.handleCreateDeductionLineItem}
    createAncillaryExpensesBudgetLineItem={ctrl.handleCreateAncillaryExpenseLineItem}
    deleteBudgetLineItem={ctrl.handleDeleteLineItem}
    autoSaveBudgetLineItem={ctrl.handleAutoSaveLineItem}
    formatCalculatedNumber={ctrl.formatCalculatedNumber}
    financeCategories={ctrl.financeCategories}
    onFinanceCategoryAdded={ctrl.addFinanceCategory}
    performers={ctrl.performers}
    onVisibilityChange={ctrl.handleVisibilityChange}
    showCurrencyConversion={ctrl.showCurrencyConversion}
    globalCurrency={ctrl.globalCurrency}
    reorderLineItem={ctrl.reorderLineItem}
    onReorderLineItems={ctrl.handleReorderLineItems}
    allLineItems={ctrl.lineItems}
    siblingRows={ctrl.siblingGuaranteeExpenses}
    onSelectSiblingOffer={ctrl.handleSelectOffer}
  />
  </div>
);

SimpleExpensesTab.propTypes = { ctrl: PropTypes.object.isRequired };

export default SimpleExpensesTab;
